import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApiService } from '@services/api.service';
import { environment } from '../environments/environment';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomMatPaginatorIntl } from './core/i18n/custom-mat-paginator-intl.service';
import { provideNativeDateAdapter } from '@angular/material/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
import { I18nService } from './core/i18n/i18n.service';

import { routes } from './app.routes';

// Registrar los datos de localización para español e inglés
registerLocaleData(localeEs);
registerLocaleData(localeEn);

// Factory para inicializar ApiService con la configuración del environment
export function initializeApiService(apiService: ApiService): () => void {
  return () => {
    apiService.setBaseUrl(environment.apiUrl);
  };
}

// Factory para obtener el locale actual según el idioma
export function getLocaleId(i18nService: I18nService): string {
  const lang = i18nService.currentLanguage();
  return lang === 'es' ? 'es-ES' : 'en-US';
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideHttpClient(withInterceptorsFromDi()), // Configurar HttpClient
    provideRouter(routes),
    provideNativeDateAdapter(), // DateAdapter para MatCalendar y MatDatepicker
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApiService,
      deps: [ApiService],
      multi: true
    },
    {
      provide: MatPaginatorIntl,
      useClass: CustomMatPaginatorIntl
    },
    {
      provide: LOCALE_ID,
      useFactory: getLocaleId,
      deps: [I18nService]
    }
  ]
};
